import { ResizeService } from 'services/ResizeService'
import { initMockResponse } from 'services/ResponseParseService'
const name = 'BUILD-GAME'

async function execute() {
  game.application.makeMain(onEnd)

  function onEnd() {
    ResizeService.resize()
    if(game.models.GameModel.mock){
      initMockResponse()
    }

    return Promise.resolve()
  }
}

export function getBuildGameAction() {
  return {
    name,
    execute,
  }
}
